/**
 * Tax is between 0 - 100
 * Do not round the value here, as we want all decimals to be stored
 */
export const computeValueWithVAT = (value = 0, tax = 0) => value * (1 + tax / 100);

/**
 * Tax is between 0 - 100
 * Do not round the value here, as we want all decimals to be stored
 */
export const computeValueWithoutVAT = (value = 0, tax = 0) => value / (1 + tax / 100);

/**
 * Percentage is between 0 - 100
 * Do not round the value here, as we want all decimals to be stored
 */
export const computeDiscount = (value = 0, percentage = 100) => (value * percentage) / 100;

/**
 * Computes percentage of a value in relation to a total
 * Do not round the value here, as we want all decimals to be stored
 * Returns a percentage between 0 - 100
 */
export const computePercentage = (value, total) => {
  if (!total) {
    return 0;
  }
  return (value * 100) / total;
};

/**
 * Rounds a value to the closest integer
 * The value 5 is rounded to the upper number (ex: 0.05 => 0.1)
 * @param {number} value
 * @param {number} [decimals=2]
 * @returns {number}
 */
export const round = (value, decimals = 2) => {
  const powerDecimal = 10 ** decimals;
  return Math.round(value * powerDecimal) / powerDecimal;
};
